<template lang="pug">
	.reconciliation-radio-tab.justify
		.radio-tab-widgets(v-if="data && !isLoading")
			.widget.flex-row
				.flex-col.padded
					span.name.black-on-white {{$tCaption('Spots')}}
					DxPieChart(:data-source="pieChartData",
						resolve-label-overlapping="shift",
						type="doughnut",
						:size="{ height: 280, width: 280 }",
						:series="[pieChartSerieConfig()]",
						:legend="{ visible: false }",
						:inner-radius="0.65",
						palette="Soft Pastel",
						center-template="centerTemplate"
					)
						DxTooltip(:enabled="true", :zIndex="100000", format="fixedPoint", :customizeTooltip="(e) => ({ text: `${e.valueText}\n${e.argument}` })")
						template(v-slot:centerTemplate="center")
							svg
								text(text-anchor="middle"
									x="100"
									y="120"
								)
									tspan(:style="{fontSize: 50, fontName: 'Roboto', fontWeight: 100, fill: '#333', letterSpacing: '-4px' }", x="100") {{max(pieChartData, 'value').percent}}%
									tspan(:style="{fontSize: 20, fontName: 'Roboto', fontWeight: 100, fill: '#333' }", x="100", dy="20px") {{max(pieChartData, 'value').name}}
				.flex-col.justify
					span.name.black-on-white {{mode === 'campaign' ? $tCaption('Campaign spots') : $tCaption('Log spots')}}
					DxChart.spots-chart(:data-source="data.CampaignSpots", :size="{ height: 280, width: 'auto' }", :palette="palette",
						:zoomAndPan="{ argumentAxis: 'both', valueAxis: 'none' }",
						:scrollBar="{ visible: true, position: 'bottom', width: 5 }"
					)
						DxSeries(value-field="ScheduledSpotsCount", name="Scheduled")
						DxSeries(value-field="AiredSpotsCount", name="Aired")
						DxLegend(:visible="true")
						DxCommonSeriesSettings(type="bar", argument-field="Date", :ignoreEmptyPoints="true")
						DxTooltip(:enabled="true", :zIndex="100000", format="fixedPoint", :customizeTooltip="customizeCampaignSpotsTooltip")
						DxValueAxis(:visible="true", :title="{ text: 'Spot count' }", color="#dedede", :grid="{ color: '#efefef' }", :tick="{ color: '#00000000' }", :label="{ font: { color: '#333' }}")
						DxArgumentAxis(:visible="true", type="discrete", argumentType="datetime", color="#efefef", :grid="{ color: '#efefef' }", :tick="{ color: '#00000000' }",
							:label="{ textOverflow: 'Ellipsis', overlappingBehavior: 'rotate', rotationAngle: 30, format: 'MM/dd/yyyy', font: { color: '#333' }}")
				.flex-col.padded.last-played.black-on-white
					.content.flex-col.space.center.align-center
						template(v-if="data.LastPlayedSpot.PlayedDateTime")
							img.logo(v-if="lastPlayedStationLogoUrl", :src="lastPlayedStationLogoUrl")
							span.station {{data.LastPlayedSpot.Station || data.LastPlayedSpot.Title}}
							.slogan(v-if="lastPlayedStation && lastPlayedStation.Slogan") {{lastPlayedStation.Slogan}}
							.flex-row.time.space.grey
								span {{$tCaption('Last played')}}
								span.accent {{lastPlayedTime()}}
							span.account {{data.LastPlayedSpot.AccountName}}
						template(v-else)
							img.logo(v-if="lastPlayedStationLogoUrl", :src="lastPlayedStationLogoUrl")
							span.time {{$tCaption('Not played yet')}}
						.flex-col.space.align-start.full-width(v-if="data.LastLoggedDate || data.LastAudioLoggingDate")
							.flex-col(v-if="data.LastLoggedDate")
								.font-small.upper.grey {{$tCaption('Last log received')}}
								span {{$moment(data.LastLoggedDate).format('LLL')}}
							.flex-col(v-if="data.LastAudioLoggingDate")
								.font-small.upper.grey {{$tCaption('Last audio log received')}}
								span {{$moment(data.LastAudioLoggingDate).format('LLL')}}
			.widget.flex-col
				span.name.black-on-white {{$tCaption('Play log')}}
				DxDataGrid.compact(width="100%", :data-source="data.Schedule", :show-borders="true", :column-hiding-enabled="true",
					:state-storing="{ enabled: true, storageKey: `${$auth.userId()}_${$options.name}` }"
					:column-chooser="{ enabled: true, mode: 'select' }", :allowColumnResizing="true", columnResizingMode="widget", :header-filter="{ visible: true }")
					DxColumn(v-if="mode !== 'station'", data-field="Station", caption="Station")
					DxColumn(data-field="Title", :caption="$tCaption('Title')")
					DxColumn(data-field="ISCI", :caption="$tCaption('ISCI')", cssClass="no-padding", v-if="$auth.countryCode() === 'US'")
					DxColumn(data-field="Material", :caption="$tCaption('Air check')", cssClass="no-padding", cellTemplate="air-check-template")
					DxColumn(data-field="PlayTime", :caption="$tCaption('Play time')", dataType="date", :format="(v) => $moment(v).format('llll')", sortOrder="desc", :sortIndex="0")
					DxColumn(data-field="PositionSold", :caption="$tCaption('Fixed position')", :visible="false")
					DxColumn(data-field="CntImpressions", :caption="$tCaption('Impressions')", v-if="mode === 'campaign' && hasImpressions", dataType="number")
					DxColumn(data-field="Duration", :caption="$tCaption('Duration')")
					DxColumn(data-field="Status", :caption="$tCaption('Status')")
					DxPaging(:page-size="10")
					template(v-slot:air-check-template="{ data }")
						.flex-row.space
							template(v-if="data.data.PlayedStatus === 2")
								.play-button(:id="`pb_${data.data.ScheduleId}`" @click="toggleActiveScheduleId(data.data.ScheduleId, data.data)", :class="{ hover: data.data.ScheduleId === activeSheduleId }")
									i.fa.fa-play
							span.overflow {{data.data.Material}}
		.widget(v-if="isLoading")
			.loading.flex-row.space.black-on-white
				.loader
					i.fas.fa-circle-notch.fa-spin
				span {{$tCaption('Loading') + '..'}}
		DxPopover(v-if="logPlayerVisible", :visible="logPlayerVisible", :shading="false", position="top", :height="160", :target="logPlayerTarget", @hiding="() => { logPlayerVisible = false; stop(); logPlayerHiding && logPlayerHiding(); }")
			.reconciliation-radio-tab.full-height.full-width.flex-row
				.content.full-height.full-width.flex-row.align-center.station-log-player.center(ref="popupPlayerWindow")
					Loader(v-if="isLoadingChunks")
					.flex-col(v-else)
						.flex-col.space(v-if="playingStation")
							.flex-col.space
								.font-small.upper.grey {{$tCaption('Playing now')}}:
								.flex-row.space.align-center
									img.station-logo(v-if="playingStationLogoUrl", :src="playingStationLogoUrl")
									.flex-col.station-info
										.station-name.nowrap.overflow {{playingStation && playingStation.Name}}
										.slogan.nowrap.overflow(v-if="playingStation && playingStation.Slogan") {{playingStation.Slogan}}
										.play-date {{$moment(playingStationTime).format('LLL')}}
						.canvas-holder
							canvas.data-canvas(ref="canvas", :width="`${canvas.width}px`", :height="`${canvas.height}px`", :style="{ width: `${canvas.width}.px`, height: `${canvas.height}px` }")
						.flex-row.align-center
							span {{currentReadableTime}}
							DxSlider(:min="0", :max="totalDuration()", :step="1", :value="currentPosition", :width="200", @valueChanged="onSliderValueChanged")
							.play-button(@click="() => { stop(); activeSheduleId = null; logPlayerVisible = false; }")
								i.fa.fa-stop
</template>

<script>
	import $ from 'jquery';
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import Data from 'app-core/Data';
	import {DxChart, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat} from 'devextreme-vue/chart';
	import {DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem} from 'devextreme-vue/data-grid';
	import DxPieChart from 'devextreme-vue/pie-chart';
	import moment from 'moment';
	import { DxPopover } from 'devextreme-vue/popover';
	import Loader from 'app-core/Loader.vue';
	import { DxSlider } from 'devextreme-vue/slider';

	export default {
		translationCategory: 'reconciliation.RadioTab',
		name: 'radio-tab',
		components: {
			DxChart, DxPaging, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat,
			DxDataGrid, DxColumn, DxSelection, DxSummary, DxTotalItem,
			DxPieChart, DxPopover, DxSlider, Loader
		},
		props: {
			data: VueTypes.any.def(null),
			mode: VueTypes.any.def(null),
			stationId: VueTypes.any.def(null),
		},
		data() {
			return {
				audioColumnWidth: 120,
				isLoading: false,
				palette: ['#d1d1d1', '#4aa97d'],
				audioContext: new AudioContext(),
				audioChunks: [],
				audioSources: [],
				isLoadingChunks: false,
				activeSheduleId: null,
				playState: 0,
				startTime: 0,
				currentContextTime: 0,
				offsetTime: 0,
				playingStation: null,
				playingItem: null,
				lastPlayedStation: null,
				playStationLogData: null,
				isLoadingNextChunks: false,
				hasNextChunks: true,
				lastChunk: 0,
				logPlayerVisible: false,
				logPlayerTarget: null,
				logPlayerHiding: null,
				playingStationTime: null,
				canvas: {
					height: 60,
					width: 220
				},
				analyser: null,
				freqs: null,
				times: null
			};
		},
		computed: {
			pieChartData() {
				return !this.data ? [] : [{ name: 'Aired', value: this.data.SpotsAired }, { name: 'Scheduled', value: this.data.SpotsNotAired }];
			},
			currentPosition() {
				return this.currentContextTime - this.startTime;
			},
			currentReadableTime() {
				return moment(0).add('seconds', this.currentPosition).format('mm:ss');
			},
			playingStationLogoUrl() {
				if (this.stationId)
					return this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.stationId}`)}&ver=${Math.random()}`);
				return !this.playingStation || !this.playingStation.HasImage ? null : this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.playingStation.Oid}`)}&ver=${Math.random()}`);
			},
			lastPlayedStationLogoUrl() {
				if (this.stationId)
					return this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.stationId}`)}&ver=${Math.random()}`);
				return !this.lastPlayedStation || !this.lastPlayedStation.HasImage ? null : this.$Data.getMethodUrl(`externalApi?accessToken=${this.$auth.accessToken()}&method=Station/GetStationImage&parameters=${encodeURIComponent(`stationId=${this.lastPlayedStation.Oid}`)}&ver=${Math.random()}`);
			},
			hasImpressions() {
				return (this.data.Schedule || []).some(f => (f.CntImpressions || 0) !== 0);
			}
		},
		watch: {
			activeSheduleId(v) {
				if (!v)
					this.stop();
			},
			'data.LastPlayedSpot'(v) {
				this.loadLastPlayedStation();
			},
			currentPosition() {
				this.checkNextChunkLoading();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.reconciliationRadioTab = this;
			this.initAudioContextData();
			this.$currentTimeUpdater = setInterval(() => this.currentContextTime = this.audioContext.currentTime, 10);
			this.$playChunks = _.debounce(this.playChunks, 100, {
				'leading': false,
				'trailing': true
			});
			this.loadLastPlayedStation();
		},
		destroyed() {
			this.stop();
			clearInterval(this.$currentTimeUpdater);
			delete this.$currentTimeUpdater;
			delete this.$playStationLog;
		},
		methods: {
			initAudioContextData() {
				this.analyser = this.audioContext.createAnalyser();

				this.analyser.connect(this.audioContext.destination);
				this.analyser.minDecibels = -140;
				this.analyser.maxDecibels = 0;

				this.freqs = new Uint8Array(this.analyser.frequencyBinCount);
				this.times = new Uint8Array(this.analyser.frequencyBinCount);
			},
			animateCanvas(val) {
				if (this.$animateCanvasInterval)
					clearInterval(this.$animateCanvasInterval);
				if (val) {
					setInterval(() => {
						if (this._isDestroyed) return;
						this.draw();
					}, 1000 / 60);
				}
			},
			draw() {
				if (!this.analyser || !this.$refs.canvas) return;
				var SMOOTHING = 0.8;
				var FFT_SIZE = 2048;
				this.analyser.smoothingTimeConstant = SMOOTHING;
				this.analyser.fftSize = FFT_SIZE;

				// Get the frequency data from the currently playing music
				this.analyser.getByteFrequencyData(this.freqs);
				this.analyser.getByteTimeDomainData(this.times);

				var width = Math.floor(1/this.freqs.length, 10);

				var drawContext = this.$refs.canvas.getContext('2d');
				drawContext.clearRect(0, 0, this.canvas.width, this.canvas.height);

				// Draw the time domain chart.
				for (let k = 0; k < this.analyser.frequencyBinCount; k++) {
					let value = this.times[k];
					let percent = value / 256;
					let height = this.canvas.height * percent;
					let offset = this.canvas.height - height - 1;
					let barWidth = this.canvas.width / this.analyser.frequencyBinCount;
					drawContext.fillStyle = '#f27649';
					drawContext.fillRect(k * barWidth, offset, 1, 1);
				}
			},
			totalDuration() {
				return this.audioChunks.reduce((total, s) => total += s.duration, 0) || 0;
			},
			checkNextChunkLoading() {
				if (this.isLoadingNextChunks || !this.playStationLogData || !this.hasNextChunks || !this.playState) return;
				var deltaToEnd = this.totalDuration() - this.currentPosition;
				if (deltaToEnd < this.playStationLogData.chunkSize && this.lastChunk < this.playStationLogData.maxChunk) {
					if (__DEBUG__)
						console.debug('Loading next chunk', { deltaToEnd, chunkSize: this.playStationLogData.chunkSize, lastChunk: this.lastChunk, maxChunk: this.playStationLogData.maxChunk });
					this.isLoadingNextChunks = true;
					this.playStationLogData.loadChunk(void 0, void 0, this.lastChunk + 1).then(data => {
						if (data && data.blob) {
							var fr = new FileReader();
							fr.readAsArrayBuffer(data.blob);
							fr.onloadend = (evt) => {
								return this.audioContext.decodeAudioData(evt.target.result, (buffer) => {
									if (__DEBUG__)
										console.debug(`Audio decoded ${data.chunk}`);
									this.audioChunks[this.audioChunks.length] = buffer;
									this.playChunks(this.currentPosition);
									this.isLoadingNextChunks = false;
								});
							};
							this.lastChunk++;
							if (this.lastChunk === this.playStationLogData.maxChunk)
								this.hasNextChunks = false;
						} else {
							this.hasNextChunks = false;
							this.isLoadingNextChunks = false;
						}
						return null;
					}).catch(() => this.isLoadingNextChunks = false);
				}
			},
			loadLastPlayedStation() {
				this.lastPlayedStation = null;
				if (this.data.LastPlayedSpot && this.data.LastPlayedSpot.StationId) {
					this.$Data.getExternalApi('Station/GetStationsByIds', `stationIds=${this.data.LastPlayedSpot.StationId}`, 1, true).then(r => this.lastPlayedStation = r[0]);
				}
			},
			onSliderValueChanged(e) {
				if (!e.event) return;
				if (__DEBUG__)
					console.debug(e);
				this.$playChunks(e.value);
			},
			toggleActiveScheduleId(v, data) {
				if (v && this.activeSheduleId === v) {
					this.activeSheduleId = null;
				} else {
					this.activeSheduleId = v;
					this.playingItem = data;
					this.logPlayerHiding = () => { if (data.ScheduleId === this.activeSheduleId) this.activeSheduleId = null; };
					this.playStationLog(data.StationId, data.PlayedDateTime, `#pb_${data.ScheduleId}`).catch(ex => {
						this.activeSheduleId = null;
						this.playingItem = null;
					});
				}
			},
			lastPlayedTime() {
				return moment(this.data.LastPlayedSpot.PlayedDateTime).fromNow();
			},
			customizeCampaignSpotsTooltip(e) {
				return {
					text: `${e.valueText} ${e.seriesName}\n${moment(e.argument).format('l')}`
				};
			},
			max(source, prop) {
				var item = _.maxBy(source, prop) || {};
				var total = _.sumBy(source, prop) || 0;
				if (!total) return 0;
				return {...item, percent: Math.floor(parseFloat(item[prop] * 100) / total) || 0};
			},
			pieChartSerieConfig() {
				return {
					argumentField: 'name',
					valueField: 'value',
					label: {
						visible: false,
						backgroundColor: 'none',
						format: 'fixedPoint',
						connector: {
							visible: true
						},
						customizeText: ({ argumentText }) => `${argumentText}`
					}
				};
			},
			refreshCanvasWidth() {
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.canvas.width = $(this.$refs.popupPlayerWindow).parent().parent().parent().width() + 50;
				});
			},
			playStationLog(stationId, dateTime, target) {
				this.animateCanvas(true);
				this.isLoadingChunks = true;
				this.playingStation = null;
				this.logPlayerVisible = false;
				this.playingStationTime = dateTime;
				if (target)
					this.logPlayerTarget = target;
				this.$Data.getExternalApi('Station/GetStationsByIds', `stationIds=${stationId}`, 1, true).then(r => {
					this.playingStation = r[0];
					this.refreshCanvasWidth();
				});
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.logPlayerVisible = true;
				});
				return (new Promise((mainRes, mainRej) =>
					this.$Data.getAzureStationLog(stationId, dateTime).then(r => {
						this.playStationLogData = r;
						this.lastChunk = r.lastChunk;
						this.audioChunks = [];
						this.hasNextChunks = !!r.data.length;
						var promises = (r.data || []).map(data => new Promise(res => {
							var fr = new FileReader();
							fr.readAsArrayBuffer(data.blob);
							fr.onloadend = (evt) => {
								return this.audioContext.decodeAudioData(evt.target.result, (buffer) => {
									if (__DEBUG__)
										console.debug(`Audio decoded ${data.chunk}`);
									this.audioChunks[data.idx] = buffer;
									res(buffer);
								});
							};
							return null;
						}));

						Promise.all(promises).finally(() => mainRes(r));
						return null;
					}).catch(ex => {
						this.audioChunks = [];
						this.logPlayerVisible = false;
						mainRej(ex);
					})
				))
				.then(() => {
					this.playChunks(moment(dateTime).seconds());
				})
				.finally(() => {
					this.isLoadingChunks = false;
				});
			},
			playChunks(offsetTime) {
				if (__DEBUG__)
					console.debug('Play chunks', { offsetTime });
				var offset = (offsetTime || 0) * -1;
				var time = this.audioContext.currentTime + offset;
				this.startTime = this.audioContext.currentTime + offset;
				this.offsetTime = offsetTime;
				this.stop();
				this.playState = 1;
				this.audioSources = this.audioChunks.map(chunk => {
					const source = this.audioContext.createBufferSource();
					source.buffer = chunk;
					var startTime = time < 0 ? 0 : time;
					var startOffset = offset < 0 ? Math.abs(offset) : 0;

					time += chunk.duration;
					offset += chunk.duration;

					if (offset > 0) {
						source.connect(this.analyser);
						source.start(startTime, startOffset);
					}

					return source;
				});
				this.refreshCanvasWidth();
			},
			stop() {
				this.playState = 0;
				this.audioSources.map(f =>{
					try {
						f.stop()
					} catch {
						//
					}
				});
				this.animateCanvas(false);
			},
		}
	};
</script>
<style lang='scss'>
	.reconciliation-radio-tab {
		@import "main/themes/generated/variables.base.scss";

		.padded {
			padding: 10px;
		}

		.last-played {
			min-width: 240px;
			width: 300px;
			justify-content: center;
			align-items: center;
			background: rgba(0,0,0,0.02);
			border-radius: 4px;

			.content {
				padding: 10px;
			}

			.time {
				font-size: 16px;

				> .accent {
					color: $base-accent;
				}
			}

			.station {
				font-size: 18px;
				text-transform: uppercase;
				text-align: center;
			}

			.account {
				font-size: 14px;
			}

			.logo {
				max-height: 120px;
				max-width: 160px;
			}
		}

		.spots-chart {
			width: calc(50vw - 100px);
			min-width: 400px;
		}

		.play-button {
			min-width: 20px;
			color: #aaa;
			cursor: pointer;

			&:hover, &.hover {
				color: $base-accent;
			}
		}

		.station-log-player {
			min-width: 300px;

			.station-info {
				max-width: 400px;
			}

			.station-name {
				font-size: 14px;
				font-weight: 800;
			}

			.play-date {
				font-size: 12px;
			}

			.station-logo {
				max-height: 60px;
				max-width: 120px;
				height: 60px;
			}
		}

		.canvas-holder {
			position: relative;
			height: 30px;
			pointer-events: none;

			> canvas {
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				top: -10px;
			}
		}
	}
</style>
